import axios from 'axios';
import {
  IPriceAlert,
  IPriceAlertCreatePayload,
  IPriceAlertUpdatePayload,
  IPriceAlertsResponse,
  IResponse,
} from '../interfaces/kattana';

export interface IPriceAlertApi {
  priceAlertEndpoint: string;
  getPriceAlerts: (
    wallet: string,
    authToken: string
  ) => Promise<IResponse<IPriceAlertsResponse>>;
  createPriceAlert: (
    payload: IPriceAlertCreatePayload,
    authToken: string
  ) => Promise<IResponse<IPriceAlert[]>>;
  updatePriceAlert: (
    uuid: string,
    wallet: string,
    payload: IPriceAlertUpdatePayload,
    authToken: string
  ) => Promise<any>;
  deletePriceALert: (
    uuid: string,
    wallet: string,
    authToken: string
  ) => Promise<any>;
}

export class PriceAlertApi implements IPriceAlertApi {
  priceAlertEndpoint: string;

  constructor(apiGateway: string) {
    if (!apiGateway) {
      apiGateway = 'https://api.kattana.trade';
    }

    this.priceAlertEndpoint = `${apiGateway}/price-alerts`;
  }

  public getPriceAlerts = async (
    wallet: string,
    authToken: string
  ): Promise<IResponse<IPriceAlertsResponse>> => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      const res = await axios.get(
        `${this.priceAlertEndpoint}/${wallet}`,
        config
      );
      return {
        success: true,
        data: res.data,
      };
    } catch (err) {
      console.warn(err);

      if (axios.isAxiosError(err)) {
        return {
          success: false,
          error: err,
        };
      }

      return {
        success: false,
      };
    }
  };

  public createPriceAlert = async (
    payload: IPriceAlertCreatePayload,
    authToken: string
  ): Promise<IResponse<IPriceAlert[]>> => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      const res = await axios.post(
        `${this.priceAlertEndpoint}`,
        payload,
        config
      );
      return {
        success: true,
        data: res.data,
      };
    } catch (err) {
      console.warn(err);

      if (axios.isAxiosError(err)) {
        return {
          success: false,
          data: [],
          error: err,
        };
      }

      return {
        success: false,
      };
    }
  };

  public updatePriceAlert = async (
    uuid: string,
    wallet: string,
    payload: IPriceAlertUpdatePayload,
    authToken: string
  ) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      const res = await axios.put(
        `${this.priceAlertEndpoint}/${uuid}/${wallet}`,
        payload,
        config
      );
      return {
        success: true,
        data: res.data,
      };
    } catch (err) {
      console.warn(err);
      return {
        success: false,
        data: [],
        error: err,
      };
    }
  };

  public deletePriceALert = async (
    uuid: string,
    wallet: string,
    authToken: string
  ) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      const res = await axios.delete(
        `${this.priceAlertEndpoint}/${uuid}/${wallet}`,
        config
      );
      return {
        success: true,
      };
    } catch (err) {
      console.warn(err);
      return {
        success: false,
      };
    }
  };
}
